import 'react-native-gesture-handler';
import { AppRegistry } from 'react-native';
import ionicons from 'react-native-vector-icons/Fonts/Ionicons.ttf';
import appConfig from './app.json';
import { App } from './src/App';

const appName = appConfig.name;

// Register the app for web
AppRegistry.registerComponent(appName, () => App);

// Run the app
AppRegistry.runApplication(appName, {
  initialProps: {},
  rootTag: document.getElementById('root'),
});

// Register Ionicons font for web rendering
const style = document.createElement('style');
style.type = 'text/css';
style.appendChild(
  document.createTextNode(
    `@font-face {font-family: 'Ionicons'; src: url(${ionicons}) format('truetype'); font-weight: normal; font-style: normal;}`
  )
);
document.head.appendChild(style);

// Set document title explicitly to prevent React Native Web from overriding it
// This fixes the issue where the title becomes "undefined" after app loads
document.title = appConfig.displayName || 'Resio';
